





















































































































































































































































































































































































































































































































































































































































import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import config from '@/config/index';
import {
  IConductor,
  IConductorGrupo,
  IConductorFile,
  IConductorCopiloto,
} from '@/interfaces/Conductores';
import { ILicenciaTipo } from '@/interfaces/Licencia';
import { IVehiculo } from '@/interfaces/Vehiculos';
import { EstadoInterface } from '@/interfaces/Estado';
import { EstadosService } from '@/services/estadosService';
import HandleErrors from '@/config/handleErrors';
import Confirmation from '@/components/Confirmation.vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Validator } from 'vee-validate';
import moment from 'moment';
import { CodigoAccion } from '@/views/base/VariablesPermisos';
import ValidaRut from '@/config/validaRut';
import { EstadoEntidad } from '@/config/enums';
import ConfigurarNotificacionConductor from '@/pantallas/Conductor/ConfigurarNotificacionConductor.vue';
import { LoadingService } from '@/services/loadingService';
import { differenceBy } from 'lodash';
import { getUserId } from '@/pantallas/Conecta/MantenedorLocalidad/helpers/getUserId';
import {
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  CellContextMenuEvent,
  RowNode,
} from 'ag-grid-community';
import { Funcionalidades } from '@/config/funcionalidades';
import { PermisoAccionVm } from '@/views/base/PermisoAccionVm';
import { ComponenteBaseStepper } from '@/views/base/ComponenteBaseStepper';
import { AlertaBackend } from '@/interfaces/Alertas';

const { AgGridVue } = require('ag-grid-vue');

@Component({
  components: {
    'ag-grid-vue': AgGridVue,
    'app-confirmacion': Confirmation,
    ConfigurarNotificacionConductor,
  },
})
export default class ConductoresModalguardarNuevoConductor extends ComponenteBaseStepper {
  @Prop({ default: false }) show!: boolean;
  @Prop({ default: () => ({ id: 0, name: '', estado: 1 }) })
  conductores!: IConductor;

  //abstract
  funcionalidad: Funcionalidades = Funcionalidades.Conductores;
  permisosActuales: PermisoAccionVm[] = [];
  axios: AxiosVue = new AxiosVue(ServicioProxy.MS);
  informacionGeneral: PermisoAccionVm = {
    accion: 'Crear - Información General',
    visible: true,
    step: 1,
    codigoSubAccion: 19,
    codigoAccionPadre: CodigoAccion.Crear,
  };

  asociarLicencias: PermisoAccionVm = {
    accion: 'Crear - Asociar Licencia',
    visible: true,
    step: 2,
    codigoSubAccion: 30,
    codigoAccionPadre: CodigoAccion.Crear,
  };

  asociarCopilotoVirtual: PermisoAccionVm = {
    accion: 'Crear - Asociar Copiloto Virtual',
    visible: true,
    step: 3,
    codigoSubAccion: 30,
    codigoAccionPadre: CodigoAccion.Crear,
  };

  permisosTotales: PermisoAccionVm[] = [
    this.informacionGeneral,
    this.asociarLicencias,
    this.asociarCopilotoVirtual,
  ];

  //Variables globales
  $snotify: any;
  e1: number = 1;
  btnText: string = 'Continuar';
  btnClass: string = 'btn-continuar';
  dialog: boolean = false;
  validForm: boolean = false;
  editedItem: IConductor = {};
  search: string = '';
  buscarLicencia: string = '';

  bottomNav: any = '1';
  dialogConfirmacion: boolean = false;
  dialogConfirmacionClose: boolean = false;
  dialogCambioEstado: boolean = false;
  estadoSeleccionado: any = '';

  licenciaAsignadosModel: any = [];
  licenciaAsignados: ILicenciaTipo[] = [];
  licenciaRespaldo: ILicenciaTipo[] = [];

  vehiculosAsignadosModel: any = [];
  vehiculosAsignados: IVehiculo[] = [];
  vehiculosRespaldo: IVehiculo[] = [];

  conductorGrupoSelected: number;
  conductorGrupo: IConductorGrupo[] = [];

  estadosClass: EstadosService = new EstadosService();
  estado: EstadoInterface[] = this.estadosClass.getEstadosVisibles();

  dictionaryFormErrors: any = {};
  handleErrors: HandleErrors = new HandleErrors();

  mensajeCambioEstado: string = '';
  disabledLicencia: boolean = false;
  mostrarMensajeCambioEstado: boolean = true;

  //grilla
  localeText: any = config.agGridTextos;
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefsLicencia: Array<ColDef> = [];
  columnDefsVehiculos: Array<ColDef> = [];
  sideBar: any = config.agGridDefaultConfig;
  autoGroupColumnDef: any = null;

  vr: ValidaRut = new ValidaRut();
  loadingService = new LoadingService();

  //CALENDARIOS
  menuDatePickerVencimientoRut: boolean = false;
  menuDatePickerNacimiento: boolean = false;
  menuDatePicker: Boolean = false;
  // fechaRenovacionLicencia: any; //= moment(new Date()).format('YYYY-MM-DD');
  defaultDate: any = moment(new Date()).format('YYYY-MM-DD');
  setRequired: boolean = false;
  seleccionoTodos: boolean = true;

  //Upload File - FormData
  uploadedFiles: any = [];
  uploadError: any = null;
  currentStatus: any = null;
  uploadFieldName: string = 'photos';

  FormDataSeleccionado: FormData;
  conductorFile: IConductorFile = {};
  imageName: any = null;
  imageUrl: any = null;
  imageFile: any = null;
  msg: string = 'Por favor espere...';
  idkey: number = 0;
  muestraLicencia: boolean = false;

  btnBloquear: Boolean = false;

  keyDatePickers: number = 0;

  //controllers
  readonly controllerConductorGrupo: string = 'conductorgrupo';
  readonly controllerConductorLicencia: string = 'ConductorLicencia';
  readonly controllerConductorVehiculo: string = 'ConductorVehiculo';
  readonly controllerConductor: string = 'conductor';
  readonly controllerVehiculo: string = 'vehiculo';
  readonly controllerLicenciaTipo: string = 'LicenciaTipo';
  readonly ControllerNotificacion: string;

  //copiloto virtual
  show3: boolean = false;
  show4: boolean = false;
  editItemCopiloto: IConductorCopiloto = {};
  alerta: AlertaBackend = {};
  tipoNotificacion: string[] = [];

  tipoNotificacionSeleccionado: number = 1;
  listaDistribucionSeleccionados: number[] = [];
  contactosSeleccionados: number[] = [];
  idsPlanesSeleccionados: number[] = [];
  usuariosSeleccionados: number[] = [];
  lsCheckSelected: number[] = [];
  camposZonaEmpty: any = '';

  axiosVehiculo: AxiosVue = new AxiosVue(ServicioProxy.Vehiculo);
  axiosUsuario: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  selectedGrupoId(e: any) {
    this.conductorGrupoSelected = e;
  }

  created() {
    this.chequearPermisos();
  }

  mounted() {
    this.initialize();
  }

  onClickCell(params: CellContextMenuEvent) {
    var appBanners = document.getElementsByClassName(
      'ag-menu'
    ) as HTMLCollectionOf<HTMLElement>;
    if (appBanners.length > 1) {
      appBanners[0].remove();
    }
  }
  cierraMenu() {
    var appBanners = document.getElementsByClassName(
      'ag-menu'
    ) as HTMLCollectionOf<HTMLElement>;
    if (appBanners.length > 0) {
      appBanners[0].remove();
    }
  }

  marcarTodoslicencia(value: boolean) {
    this.licenciaAsignadosModel = [];
    this.licenciaAsignados = [];
    if (value) {
      this.licenciaRespaldo.forEach((cliente: any) => {
        this.licenciaAsignadosModel.push(cliente.id);
        this.licenciaAsignados.push(cliente);
      });
    } else {
      this.licenciaRespaldo.forEach((cliente: any) => {
        cliente.fechaRenovacionDocumento = null;
      });
    }
    this.seleccionoTodos = value;
  }

  volver() {
    this.e1 -= 1;
    this.$validator.errors.clear();
    this.btnText = 'Continuar';
    this.btnClass = 'btn-continuar';
    document.getElementById('cardDivC').scrollIntoView(true);
  }

  existeValorTodasCeldaguardarNuevoConductor(grid: any, nombreColumna: string) {
    let res: any = true;
    if (grid != undefined) {
      grid.forEachNode(function(rowNode: any) {
        if (
          (rowNode.data[nombreColumna] === null ||
            rowNode.data[nombreColumna] === '') &&
          res
        ) {
          res = false;
        }
      });
    }

    return res;
  }

  @Watch('show')
  async onPropertyChanged(value: boolean, oldValue: boolean) {
    this.idkey += 1;
    this.dialog = value;
    this.btnText = 'Continuar';
    this.btnClass = 'btn-continuar';
    this.setRequired = false;

    this.licenciaAsignados = [];
    this.licenciaAsignadosModel = [];
    this.vehiculosAsignados = [];
    this.vehiculosAsignadosModel = [];

    this.FormDataSeleccionado = null;
    //this.editedItem.estado = EstadoEntidad.Activo;

    this.imageName = null;
    this.imageUrl = null;
    this.imageFile = null;

    if (value) {
      this.loadingService.showLoading();
      this.editedItem = {};
      this.$validator.reset();
      this.$validator.errors.clear();
      this.registrarValidadores();

      try {
        this.editedItem.estado = EstadoEntidad.Activo;
        await this.obtenerLicencias();
        //await this.obtenerVehiculos();
        await this.obtenerGrupoConductores();
        this.seleccionoTodos = false;
        this.editItemCopiloto.estado = EstadoEntidad.Activo;
      } catch (error) {
        this.loadingService.hideLoading();
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            this.handleErrors.showError(error);
          }
        } else {
          this.handleErrors.showError(error);
        }
      } finally {
        this.loadingService.hideLoading();
      }
    }
  }

  async obtenerGrupoConductores() {
    try {
      const response = await this.axiosVehiculo.http.get(
        `${
          this.controllerConductorGrupo
        }/${config.getClienteSesion()}/GrupoConductoresCliente`
      );
      this.conductorGrupo = response.data;
    } catch (error) {
      this.loadingService.hideLoading();
      if (error.response !== undefined) {
        if (error.response.status !== 401) {
          this.handleErrors.showError(error);
        }
      } else {
        this.handleErrors.showError(error);
      }
    }
  }

  async obtenerLicencias() {
    try {
      const response = await this.axiosVehiculo.http.get(
        `${this.controllerLicenciaTipo}/`
      );
      this.licenciaRespaldo = response.data;
    } catch (error) {
      this.loadingService.hideLoading();
      if (error.response !== undefined) {
        if (error.response.status !== 401) {
          this.handleErrors.showError(error);
        }
      } else {
        this.handleErrors.showError(error);
      }
    }
    if (this.licenciaRespaldo.length > 0) {
      this.muestraLicencia = true;
    } else {
      this.muestraLicencia = false;
    }
  }

  onLicenciaChange(lic: any) {
    window.setTimeout(() => {
      this.search = '';
    }, 100);
    if (lic !== undefined && lic.length !== this.licenciaAsignados.length) {
      for (let x = this.licenciaAsignados.length - 1; x >= 0; x--) {
        let borrar = true;

        for (let i = 0; i <= lic.length - 1; i++) {
          if (this.licenciaAsignados[x].id == lic[i]) {
            borrar = false;
          }
        }

        if (borrar) {
          this.licenciaAsignados[x].fechaRenovacionDocumento = null; //Actualiza Fecha Renovacion Licencia
          this.licenciaAsignados.splice(x, 1);
        }
        if (this.licenciaAsignados.length === this.licenciaRespaldo.length)
          this.seleccionoTodos = true;
        else this.seleccionoTodos = false;
      }
    }
  }

  onLicenciaInput(lic: any) {
    if (lic !== undefined) {
      for (let i = 0; i <= lic.length - 1; i++) {
        let added = this.licenciaAsignados.filter(x => x.id == lic[i]);

        if (added.length === 0) {
          let licenciaAsignar = this.licenciaRespaldo.find(x => x.id == lic[i]);
          this.licenciaAsignados.push(licenciaAsignar);
          if (this.licenciaAsignados.length === this.licenciaRespaldo.length)
            this.seleccionoTodos = true;
          else this.seleccionoTodos = false;
        }
      }
    }
  }

  removerLicenciaAsignacion(item: ILicenciaTipo) {
    for (let i = 0; i <= this.licenciaAsignadosModel.length - 1; i++) {
      if (this.licenciaAsignadosModel[i] == item.id) {
        this.licenciaAsignadosModel.splice(i, 1);
        break;
      }
    }
    for (let i = 0; i <= this.licenciaAsignados.length - 1; i++) {
      if (this.licenciaAsignados[i].id == item.id) {
        this.licenciaAsignados.splice(i, 1);
        break;
      }
    }
    if (this.licenciaAsignadosModel.length === this.licenciaRespaldo.length) {
      this.seleccionoTodos = true;
    } else {
      this.seleccionoTodos = false;
    }
    var appBanners = document.getElementsByClassName(
      'fechaRenovacionDocumento'
    ) as HTMLCollectionOf<HTMLElement>;
    if (appBanners.length === 1) {
      appBanners[0].remove();
    }
  }

  async obtenerVehiculos() {
    try {
      const response = await this.axiosVehiculo.http.get(
        `${
          this.controllerVehiculo
        }/${config.getClienteSesion()}/vehiculosCliente`
      );
      this.vehiculosRespaldo = response.data;
    } catch (error) {
      this.loadingService.hideLoading();
      if (error.response !== undefined) {
        if (error.response.status !== 401) {
          this.handleErrors.showError(error);
        }
      } else {
        this.handleErrors.showError(error);
      }
    }
  }

  onVehiculosChange(vehiculo: any) {
    if (
      vehiculo != undefined &&
      vehiculo.length != this.vehiculosAsignados.length
    ) {
      for (let x = this.vehiculosAsignados.length - 1; x >= 0; x--) {
        let borrar = true;
        for (let i = 0; i <= vehiculo.length - 1; i++) {
          if (this.vehiculosAsignados[x].id == vehiculo[i]) {
            borrar = false;
          }
        }
        if (borrar) {
          this.vehiculosAsignados.splice(x, 1);
        }
      }
    }
  }

  onVehiculosInput(vehiculo: any) {
    if (vehiculo != undefined) {
      for (let i = 0; i <= vehiculo.length - 1; i++) {
        let added = this.vehiculosAsignados.filter(x => x.id == vehiculo[i]);
        if (added.length == 0) {
          let _vehiculo = this.vehiculosRespaldo.filter(
            x => x.id == vehiculo[i]
          );
          this.vehiculosAsignados.push(_vehiculo[0]);
        }
      }
    }
  }

  removerVehiculosAsignacion(item: IVehiculo) {
    for (let i = 0; i <= this.vehiculosAsignados.length - 1; i++) {
      if (this.vehiculosAsignados[i].id == item.id) {
        this.vehiculosAsignados.splice(i, 1);
        break;
      }
    }

    for (let i = 0; i <= this.vehiculosAsignadosModel.length - 1; i++) {
      if (this.vehiculosAsignadosModel[i] == item.id) {
        this.vehiculosAsignadosModel.splice(i, 1);
        break;
      }
    }
  }

  closeModal(val: boolean) {
    document.getElementById('cardDivC').scrollIntoView(true);
    this.$validator.reset();
    this.$validator.errors.clear();
    this.setRequired = false;
    this.btnBloquear = false;
    this.buscarLicencia = '';
    this.gridApi.setQuickFilter('');
    this.editedItem = {};
    this.FormDataSeleccionado = null;
    this.e1 = 1;
    this.keyDatePickers += 1;
    this.$emit('modalAsociacionEmit', false);
    this.dialog = false;
  }

  formatoTextoAsociacion(texto: string) {
    return config.largoTextoAsociacion(texto);
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
  }
  validacionApellido() {
    return this.editedItem.codigoConductor ? '' : 'required|max:20|alpha_num';
  }
  validacionApellidoMaterno() {
    return this.editedItem.codigoConductor ? '' : 'max:20|alpha_num';
  }
  async continuar() {
    const resultado = await this.$validator.validateAll();

    if (this.editedItem.codigoConductor) {
      // Si se coloca el código de autorización, solo se valida grupo
      if (!this.editedItem.conductorGrupoId) {
        this.errors.add({
          field: 'conductorGrupoId',
          msg: 'Campo requerido',
        });
        if (!this.editedItem.nombre) {
          this.errors.add({
            field: 'nombre',
            msg: 'Campo requerido',
          });
        }
      }
    } else {
      // Si no hay código de autorización, todos los campos deben ser obligatorios
      if (!this.editedItem.rut) {
        this.errors.add({ field: 'rut', msg: 'Campo requerido' });
      }

      if (!this.editedItem.apellidoPaterno) {
        this.errors.add({
          field: 'apellidoPaterno',
          msg: 'Campo requerido',
        });
      }

      if (!this.editedItem.conductorGrupoId) {
        this.errors.add({
          field: 'conductorGrupoId',
          msg: 'Campo requerido',
        });
      }

      if (!this.editedItem.nombre) {
        this.errors.add({
          field: 'nombre',
          msg: 'Campo requerido',
        });
      }
    }

    if (resultado && this.errors.items.length === 0) {
      document.getElementById('cardDivC').scrollIntoView(true);

      if (this.e1 === this.permisosActuales.length - 1) {
        this.btnBloquear = true;
        this.dialogConfirmacion = true;
      } else if (
        this.e1 === this.permisosActuales.length - 2 &&
        !this.disabledLicencia
      ) {
        this.e1 += 1;
        this.btnText = 'Guardar';
        this.btnClass = 'btn-grabar';
      } else if (
        this.e1 === this.permisosActuales.length - 2 &&
        this.disabledLicencia
      ) {
        this.btnBloquear = true;
        this.dialogCambioEstado = true;
      } else {
        this.e1 += 1;
      }
    }
  }

  async initialize() {
    //this.editedItem.estado = EstadoEntidad.Activo;
    this.columnDefsLicencia = [
      {
        headerName: '',
        field: 'checked',
        width: 70,
        minWidth: 70,
        pinned: 'left',
        checkboxSelection: true,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        suppressMenu: true,
        resizable: true,
        sortable: true,
        filter: false,
        suppressMovable: true,
        lockVisible: true,
        cellStyle: { textAlign: 'left' },
        cellRenderer: (r: any) => {
          if (r.data.checked !== undefined) {
            return r.node.setSelected(r.data.checked);
          }
        },
      },
      {
        headerName: 'Código',
        field: 'id',
        rowDrag: true,
        enablePivot: true,
        lockPinned: true,
        minWidth: 80,
        resizable: true,
        hide: true,
        sortable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Clase',
        field: 'clase',
        rowDrag: false,
        lockPinned: true,
        resizable: true,
        width: 200,
        minWidth: 80,
        enablePivot: true,
        sortable: true,
        lockVisible: true,
        cellStyle: { textAlign: 'left' },
        comparator: function(valueA, valueB, nodeA, nodeB, isInverted) {
          return config.caseInsensitiveSort(
            valueA,
            valueB,
            nodeA,
            nodeB,
            isInverted
          );
        },
      },
      {
        headerName: 'Nombre',
        field: 'nombre',
        rowDrag: true,
        lockPinned: true,
        resizable: true,
        width: 200,
        minWidth: 80,
        enablePivot: true,
        sortable: true,
        cellStyle: { textAlign: 'left' },
        comparator: function(valueA, valueB, nodeA, nodeB, isInverted) {
          return config.caseInsensitiveSort(
            valueA,
            valueB,
            nodeA,
            nodeB,
            isInverted
          );
        },
      },
    ];

    this.dictionaryFormErrors = {
      custom: {
        rut: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
        },
        Nombre: {
          required: () => config.errorMensajes.textoRequerido,
          max: config.errorMensajes.maxLength,
          alpha_num: () =>
            '* Solo se permiten letras y/o numeros, sin espacios.',
        },
        apellidoPaterno: {
          required: () => config.errorMensajes.textoRequerido,
          max: config.errorMensajes.maxLength,
          alpha_num: () =>
            '* Solo se permiten letras y/o numeros, sin espacios.',
        },
        'Apellido Materno': {
          required: () => config.errorMensajes.textoRequerido,
          max: config.errorMensajes.maxLength,
          alpha_num: () =>
            '* Solo se permiten letras y/o numeros, sin espacios.',
        },
        referencia: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
        },
        estado: {
          required: () => config.errorMensajes.textoRequerido,
        },
        conductorGrupo: {
          required: () => config.errorMensajes.textoRequerido,
        },
        'correo electrónico': {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
        },
        'Teléfono Celular': {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
        },
        vencimientoRut: {
          required: () => config.errorMensajes.textoRequerido,
        },
        fechaNacimiento: {
          mayorDeEdad: () => config.errorMensajes.fechaMayoriaEdad,
          fechaNacimiento: () => config.errorMensajes.fechaNacimientoMenorAHoy,
          required: () => config.errorMensajes.textoRequerido,
        },
        FechaRenovacion: {
          ValidadorFechaRenovacionguardarNuevoConductor: () =>
            config.errorMensajes.faltaFechaRenovacion,
        },
        codigoConductor: {
          max: () => config.errorMensajes.maxLength,
        },
        email: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
        },
        fechaRenova: {
          required: () => config.errorMensajes.textoRequerido,
        },
        horasDisponible: {
          numeric: config.errorMensajes.soloNumeros,
          max_value: () => config.errorMensajes.maxLength,
          min_value: () => '* El valor no puede ser negativo.',
        },
      },
    };

    this.$validator.localize('es', this.dictionaryFormErrors);
  }

  createButtonCellLicencias(params: any) {
    const item = this.licenciaRespaldo.find(x => x.id == params.data.id);

    let eButton = document.createElement('button');
    eButton.setAttribute('id', 'btnLic' + params.data.id);
    eButton.setAttribute('title', 'Remover');
    eButton.setAttribute('class', 'v-btn v-btn--flat v-btn--icon theme--light');
    eButton.innerHTML =
      '<div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons theme--light">delete</i></div>';

    eButton.addEventListener('click', () => {
      item.fechaRenovacionDocumento = null;
      this.removerLicenciaAsignacion(item);
    });

    return eButton;
  }

  createButtonCellVehiculos(params: any) {
    const item = this.vehiculosRespaldo.find(x => x.id == params.data.id);

    let eButton = document.createElement('button');
    eButton.setAttribute('id', 'btnLic' + params.data.id);
    eButton.setAttribute('title', 'Remover');
    eButton.setAttribute('class', 'v-btn v-btn--flat v-btn--icon theme--light');
    eButton.innerHTML =
      '<div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons theme--light">delete</i></div>';

    eButton.addEventListener('click', () => {
      this.removerVehiculosAsignacion(item);
    });

    return eButton;
  }
  formatDate(fecha: Date): string {
    if (!fecha) return null;
    const [year, month, day] = fecha.toString().split('-');
    return `${day}/${month}/${year}`;
  }

  async guardarNuevoConductor() {
    const he = new HandleErrors();
    const userId = getUserId();
    const model = {
      rut: this.editedItem.rut || '',
      nombre: this.editedItem.nombre,
      apellidoPaterno: this.editedItem.apellidoPaterno,
      apellidoMaterno: this.editedItem.apellidoMaterno,
      referencia: this.editedItem.referencia,
      email: this.editedItem.email || '',
      telefono: this.editedItem.telefono,
      fechaNacimiento: this.editedItem.fechaNacimiento,
      fechaVencimientoRut: this.editedItem.fechaVencimientoRut,
      conductorGrupoId: this.conductorGrupoSelected,
      idElectroctonico: '0',
      estado: this.editedItem.estado,
      codigoConductor: this.editedItem.codigoConductor,
      horasDisponibleConduccion: this.editedItem.horasDisponibleConduccion,
      nombreCompleto: `${this.editedItem.nombre} ${this.editedItem.apellidoPaterno}`,
    };

    try {
      this.loadingService.showLoading();
      const response = await this.axiosVehiculo.http.post(
        `${this.controllerConductor}/`,
        model
      );
      if (this.FormDataSeleccionado != null) {
        await this.upFile(response.data.id, this.FormDataSeleccionado);
      }

      // guarda licencias cuando el estado se encuentra Activo
      if (this.editedItem.estado === 0) {
        this.licenciaAsignados = [];
      }

      await this.guardarAsociacionesLicencia(response.data.id);
      //await this.guardarCopilotoVirtual(response.data.id);
    } catch (error) {
      this.loadingService.hideLoading();
      if (error.response !== undefined) {
        if (error.response.status !== 401) {
          this.errorMSG(error, he);
        }
      } else {
        this.errorMSG(error, he);
      }
    } finally {
      this.loadingService.hideLoading();
    }
  }

  async guardarAsociacionesLicencia(conductorId: number) {
    let conductorLicenciaModelListPost: any = [];

    if (this.licenciaAsignados.length > 0) {
      const he = new HandleErrors();

      this.licenciaAsignados.forEach((licencias: any) => {
        let licenciaModel = licencias;
        licenciaModel = {
          licenciaTipoId: licencias.id,
          conductorId: conductorId,
          fechaRenovacionDocumento: this.editedItem.fechaRenovacionDocumento,
          rut: this.editedItem.rut || '',
        };

        conductorLicenciaModelListPost.push(licenciaModel);
      });

      if (conductorLicenciaModelListPost.length > 0) {
        try {
          const response = await this.axiosVehiculo.http.post(
            `${this.controllerConductorLicencia}/`,
            conductorLicenciaModelListPost
          );
          this.close();
        } catch (error) {
          this.loadingService.hideLoading();
          if (error.response !== undefined) {
            if (error.response.status !== 401) {
              this.errorMSG(error, he);
            }
          } else {
            this.errorMSG(error, he);
          }
        }
      } else {
        this.close();
      }
    } else {
      this.close();
    }
  }

  async guardarCopilotoVirtual(conductorId: number) {
    const copilotoModel = {
      conductorId: conductorId,
      notificaEmail: this.editItemCopiloto.email,
      notificaWhatsApp: this.editItemCopiloto.whatsApp,
      notificaSms: this.editItemCopiloto.sms,
      estado: this.editItemCopiloto.estado,
      password: this.editItemCopiloto.password,
      usuarios: this.alerta.notificacionUsuario,
      contactos: this.alerta.notificacionContacto,
      listaDistribucion: this.alerta.notificacionListaDistribucion,
    };

    const response = await this.axiosVehiculo.http.post(
      `${this.controllerConductor}/asociarCopiloto`,
      copilotoModel
    );
  }

  async guardarAsociacionesVehiculo(conductorId: number) {
    let conductorVehiculoModelListPost: any = [];

    if (this.vehiculosAsignados.length > 0) {
      const he = new HandleErrors();

      this.vehiculosAsignados.forEach((vehiculo: any) => {
        let vehiculoModel = vehiculo;

        vehiculoModel = {
          vehiculoId: vehiculo.id,
          conductorId: conductorId,
          fechaInicialAsignacion: new Date(),
        };

        conductorVehiculoModelListPost.push(vehiculoModel);
      });

      if (conductorVehiculoModelListPost.length > 0) {
        try {
          const response = await this.axiosVehiculo.http.post(
            `${this.controllerConductorVehiculo}/`,
            conductorVehiculoModelListPost
          );

          this.close();
        } catch (error) {
          this.loadingService.hideLoading();
          if (error.response !== undefined) {
            if (error.response.status !== 401) {
              this.errorMSG(error, he);
            }
          } else {
            this.errorMSG(error, he);
          }
        }
      } else {
        this.close();
      }
    } else {
      this.close();
    }
  }

  seleccionarEstado(tipoEstado: any) {
    this.estadoSeleccionado = tipoEstado;

    switch (this.estadoSeleccionado) {
      case 1: // estado Activo
        this.disabledLicencia = false;
        this.mensajeCambioEstado = '';
        this.btnText = 'Continuar';
        this.btnClass = 'btn-continuar';
        break;

      case 0: // estado Inactivo
        this.disabledLicencia = true;
        this.mensajeCambioEstado =
          'Al dejar como inactivo, no se podrán realizar asociaciones.';
        this.btnText = 'Guardar';
        this.btnClass = 'btn-grabar';
        this.vehiculosAsignados = [];
        this.vehiculosAsignadosModel = [];
        break;
    }
  }

  confirmCallbackEstado(aceptado: boolean) {
    this.dialogCambioEstado = false;

    if (aceptado === true) {
      this.btnText = 'Guardar';
      this.btnClass = 'btn-grabar';
      this.confirmCallback(aceptado);
      this.disabledLicencia = true;
    } else {
      this.editedItem.estado = 0;
      this.btnBloquear = false;
      this.disabledLicencia = true;
      this.btnText = 'Guardar';
      this.btnClass = 'btn-grabar';
    }
  }

  close() {
    this.editedItem.fechaVencimientoRut = new Date();
    this.editedItem.fechaNacimiento = new Date();
    this.loadingService.hideLoading();
    this.closeModal(false);
    this.$snotify.success(
      this.$t('mensajes.mensajesExito.crear', {
        entidad: 'Conductor',
        creadoA: 'creado',
      })
    );
  }

  //COMPUTED
  get computedDateFormattedVencimientoRut() {
    return this.formatDate(this.editedItem.fechaVencimientoRut);
  }

  get computedDateFormattedNacimiento() {
    return this.formatDate(this.editedItem.fechaNacimiento);
  }
  get computedDateFormatted() {
    return this.formatDate(this.editedItem.fechaRenovacionDocumento);
  }

  reset() {
    this.uploadedFiles = [];
    this.uploadError = null;
  }

  async upFile(id: number, formData: any) {
    const he = new HandleErrors();
    try {
      const response = await this.axiosVehiculo.http.put(
        `${this.controllerConductor}/${id}/foto`,
        formData
      );
    } catch (error) {
      this.loadingService.hideLoading();
      if (error.response !== undefined) {
        if (error.response.status !== 401) {
          this.errorMSG(error, he);
        }
      } else {
        this.errorMSG(error, he);
      }
    }
  }

  onFilePicked(e: any) {
    var formData = new FormData();

    const files = e.target.files;
    if (files[0] !== undefined) {
      this.imageName = files[0].name;

      if (this.imageName.lastIndexOf('.') <= 0) {
        return;
      }

      const fr = new FileReader();
      fr.readAsDataURL(files[0]);

      fr.addEventListener('load', () => {
        this.imageUrl = fr.result;
        this.imageFile = files[0]; // Este es el Archivo que se envia al server.
      });

      formData.append('ConductorFile', files[0]);

      this.FormDataSeleccionado = formData;
    } else {
      this.imageName = null;
      this.imageFile = null;
      this.imageUrl = null;
    }
  }

  async confirmCallback(val: boolean) {
    this.dialogConfirmacion = false;
    const he = new HandleErrors();

    if (val) {
      const resultadoValidacion = await this.$validator.validateAll();
      this.btnBloquear = true;
      const boolError = await this.guardarNuevoConductor();
    }

    this.btnBloquear = false;
  }

  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = false;
    if (val) {
      this.closeModal(false);
    }
  }

  errorMSG(error: any, he: HandleErrors) {
    //he.showError(error);
    this.$snotify.error(
      this.$t('mensajes.mensajesError.crear', { entidad: 'el Conductor' })
    );
    this.btnBloquear = false;
  }

  registrarValidadores() {
    const validarRut = this.vr;
    const item = this.editedItem;
    const self = this;
    // debugger;
    Validator.extend('rut', {
      getMessage(field: any, params: any, data: any) {
        return (data && data.message) || '* Rut inválido';
      },
      validate(value: any) {
        return new Promise(resolve => {
          resolve({
            valid: validarRut.Rut(value),
            data: validarRut.Rut(value)
              ? undefined
              : { message: '* Rut inválido' },
          });
        });
      },
    });
    Validator.extend('rutFormato', {
      getMessage(field: any, params: any, data: any) {
        return (data && data.message) || '* Rut inválido';
      },
      validate(value: any) {
        return new Promise(resolve => {
          resolve({
            valid: validarRut.validaFormatoRut(value),
            data: validarRut.validaFormatoRut(value)
              ? undefined
              : { message: '* Rut inválido' },
          });
        });
      },
    });

    Validator.extend('rutUnicoPorCliente', {
      getMessage() {
        return '* El RUT ya se encuentra en uso.';
      },
      validate(value: any) {
        return self.axiosVehiculo.http
          .get(
            `${
              self.controllerConductor
            }/0/${config.getClienteSesion()}/${value}/rutUnicoPorCliente`
          )
          .then(response => {
            return new Promise(resolve => {
              resolve({
                valid: response.data,
                data: response.data
                  ? undefined
                  : { message: '* El RUT ya se encuentra en uso.' },
              });
            });
          })
          .catch(() => {
            return true;
          });
      },
    });

    Validator.extend('EmailConductorUnicoPorCliente', {
      getMessage() {
        return '* El correo ya se encuentra en uso.';
      },
      validate(value: any) {
        return self.axiosVehiculo.http
          .get(
            `${
              self.controllerConductor
            }/0/${config.getClienteSesion()}/${value}/EmailUnicoPorCliente`
          )
          .then(response => {
            return new Promise(resolve => {
              resolve({
                valid: response.data,
                data: response.data
                  ? undefined
                  : { message: '* El correo ya se encuentra en uso.' },
              });
            });
          })
          .catch(() => {
            return true;
          });
      },
    });

    Validator.extend('ValidadorFechaRenovacionguardarNuevoConductor', {
      getMessage(field: any, params: any, data: any) {
        //return (data && data.message) || '* Seleccione la Fecha de Renovación del Documento';
        return '* Seleccione la Fecha de Renovación del Documento';
      },
      validate(value: any) {
        if (self.e1 != 1) {
          return self.existeValorTodasCeldaguardarNuevoConductor(
            self.gridApi,
            'fechaRenovacionDocumento'
          );
        } else {
          return true;
        }
      },
    });

    Validator.extend('fechaNacimiento', {
      getMessage(field: any, params: any, data: any) {
        return (
          (data && data.message) ||
          '* Fecha Nacimiento no puede ser mayor a hoy'
        );
      },
      validate(value: any) {
        return validarRut.validaFechaNacimiento(value);
      },
    });

    Validator.extend('mayorDeEdad', {
      getMessage(field: any, params: any, data: any) {
        return (
          (data && data.message) ||
          '* Fecha Nacimiento no cumple con mayoría de edad'
        );
      },
      validate(value: any) {
        return validarRut.validaMayorEdad(value);
      },
    });
  }

  fechaRDFilter(r: any) {
    if (r.value == null) return this.celdaFechaRenovacionTemplate('');

    if (r.value.length < 11) {
      if (r.value.indexOf('-') > -1) {
        const [year, month, day] = r.value.split('-');

        return this.celdaFechaRenovacionTemplate(`${day}/${month}/${year}`);
      } else {
        return this.celdaFechaRenovacionTemplate(r.value);
      }
    }

    return this.celdaFechaRenovacionTemplate(
      this.$options.filters.formatDate(r.value)
    );
  }

  celdaFechaRenovacionTemplate(fecha: any) {
    let divPadre = document.createElement('div');

    let div = document.createElement('div');
    div.style.width = '15%';
    div.style.cssFloat = 'left';

    let divInputPrepend = document.createElement('div');
    divInputPrepend.className = 'v-input__prepend-outer';
    divInputPrepend.style.paddingTop = '5px !important';

    let divInputIcon = document.createElement('div');
    divInputIcon.className = 'v-input__icon v-input__icon--prepend';

    let imagen = document.createElement('i');
    imagen.className = 'v-icon material-icons theme--light';
    imagen.innerText = 'event';
    imagen.setAttribute('aria-hidden', 'true');

    div.appendChild(divInputPrepend);
    divInputPrepend.appendChild(divInputIcon);
    divInputIcon.appendChild(imagen);

    let divFecha = document.createElement('div');
    divFecha.style.width = '82%';
    divFecha.style.cssFloat = 'left';
    divFecha.style.paddingLeft = '5px';
    divFecha.innerText = fecha;

    divPadre.appendChild(div);
    div.insertAdjacentElement('afterend', divFecha);

    return divPadre;
  }
  async onSelectionChangedConductor() {
    await this.ordena();
    this.licenciaAsignados = this.gridApi.getSelectedRows();
    if (this.licenciaAsignados.length > 0) {
      this.setRequired = true;
    } else {
      if (this.editedItem.fechaRenovacionDocumento != undefined) {
        this.editedItem.fechaRenovacionDocumento = undefined;
      }
      this.setRequired = false;
    }
  }
  getRowNodeIdLicencia(lic: ILicenciaTipo) {
    if (!lic) {
      return;
    }
    return lic.id;
  }
  onFilterTextBoxChangedLicencia() {
    this.gridApi.onFilterChanged();
    // if (this.buscarLicencia.length > 1) {
    //   this.gridApi.setQuickFilter(this.buscarLicencia);
    // } else {
    //   this.gridApi.setQuickFilter('');
    // }
  }
  ordena() {
    const licenciasSeleccionados = this.gridApi
      .getSelectedNodes()
      .map(node => ({ ...node.data, checked: true }));

    const licenciasNoSeleccionados = differenceBy(
      this.licenciaRespaldo,
      licenciasSeleccionados,
      licenc => licenc.id
    ).map(licenc => ({
      ...licenc,
      licenc: false,
    }));
    this.gridApi.updateRowData({
      update: [...licenciasNoSeleccionados, ...licenciasSeleccionados],
    });
  }

  isExternalFilterPresentLicencia(): boolean {
    return true;
  }

  doesExternalFilterPassLicencia(node: RowNode): boolean {
    if (this.licenciaRespaldo.length > 0 && this.buscarLicencia.length > 1) {
      let busqueda = this.buscarLicencia.toLowerCase();
      return (
        node.data.nombre.toLowerCase().includes(busqueda) ||
        node.data.clase.toLowerCase().includes(busqueda)
      );
    }
    return true;
  }

  //

  handledTipoNotificacion(tipoNotificacion: number) {
    this.tipoNotificacionSeleccionado = tipoNotificacion;
  }

  handleDistribucionSelect(
    lstNotificacion: number[],
    tipoNotificacion: number
  ) {
    console.log('tiponotifca', tipoNotificacion);
    if (tipoNotificacion == 1) {
      this.alerta.notificacionListaDistribucion = lstNotificacion;
      this.listaDistribucionSeleccionados = lstNotificacion;
    } else if (tipoNotificacion == 2) {
      this.alerta.notificacionContacto = lstNotificacion;
      this.contactosSeleccionados = lstNotificacion;
    } else {
      this.alerta.notificacionUsuario = lstNotificacion;
      this.usuariosSeleccionados = lstNotificacion;
    }
  }
  CheckNotificacion(e: Event) {
    this.editItemCopiloto.whatsApp = this.tipoNotificacion.includes('WhatsApp')
      ? true
      : false;
    this.editItemCopiloto.sms = this.tipoNotificacion.includes('SMS')
      ? true
      : false;
    this.editItemCopiloto.email = this.tipoNotificacion.includes('Email')
      ? true
      : false;

    // if (this.tipoNotificacion.includes('WhatsApp')) {
    //   this.editItemCopiloto.whatsApp = true;
    // }

    // if (this.tipoNotificacion.includes('SMS')) {
    //   this.editItemCopiloto.sms = true;
    // }

    // if (this.tipoNotificacion.includes('Email')) {
    //   this.editItemCopiloto.email = true;
    // }
  }
}
